const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1024 1025",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-3318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_4",
    transform: "matrix(1,0,0,1,3.18323e-12,3318.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(35,132,198)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1078.75,-1121.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1811.61,1672.34C1752.58,1784.27 1638.82,1860.13 1508.31,1860.13C1371.81,1860.13 1253.65,1777.16 1197.23,1656.72C1190.21,1641.77 1190.21,1624.47 1197.23,1609.51C1253.65,1489.08 1371.81,1406.1 1508.31,1406.1C1638.82,1406.1 1752.58,1481.96 1811.61,1593.89C1826.28,1523.84 1879.43,1467.87 1947.9,1449.13C1953.51,1447.61 1959.47,1449.55 1963.12,1454.06C1966.76,1458.57 1967.4,1464.81 1964.75,1469.97C1939.61,1518.89 1925.43,1574.36 1925.43,1633.12C1925.43,1691.87 1939.61,1747.34 1964.73,1796.27C1967.38,1801.42 1966.75,1807.65 1963.1,1812.16C1959.46,1816.67 1953.5,1818.6 1947.91,1817.09C1879.43,1798.37 1826.28,1742.39 1811.61,1672.34Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1078.75,-1121.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1510.31,1379.11C1551.6,1343.01 1601.53,1316.64 1656.29,1303.3C1659.88,1302.44 1663.63,1303.83 1665.8,1306.82C1667.96,1309.81 1668.1,1313.82 1666.16,1316.95C1650.29,1342.84 1636.29,1370.03 1624.37,1398.35C1588.41,1386.06 1550.08,1379.32 1510.31,1379.11Z",
    style: {
      fill: "white"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0679479,0,0,0.0679479,211.828,413.044)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "rgb(35,132,198)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.9e3f45074613160b06607cf6e1d02079.svg";
export { ForwardRef as ReactComponent };